export enum EOfferScopeStatus {
	none = 'none',
	active = 'active',
	paused = 'paused',
	closed = 'closed',
}

export const OFFER_SCOPE_STATUS_LABEL_MAP: Record<EOfferScopeStatus, string> = {
	[EOfferScopeStatus.none]: `offer_scope_status.${EOfferScopeStatus.none}`,
	[EOfferScopeStatus.active]: `offer_scope_status.${EOfferScopeStatus.active}`,
	[EOfferScopeStatus.paused]: `offer_scope_status.${EOfferScopeStatus.paused}`,
	[EOfferScopeStatus.closed]: `offer_scope_status.${EOfferScopeStatus.closed}`
}